import axios from "axios";
import queryString from "query-string";

export const url =
  process.env.NODE_ENV === "production"
    ? "https://api.pim.tradesk.pl"
    : "http://localhost:3001";

export const api_url = `${url}/v3`;

export const client = axios.create({ baseURL: api_url });

client.interceptors.response.use(
  function (response) {
    return response.data;
  },
  function (error) {
    return Promise.reject(error);
  },
);

export const authorizeApi = (token) => {
  client.defaults.headers.common["Authorization"] = token;
};

export const handleErrors = (data) => {
  try {
    const errors = {};
    data.forEach(({ detail, source: { pointer } }) => {
      errors[pointer.split("/")[pointer.split("/").length - 1]] = detail;
    });
    return errors;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getApiErrorMessage = (error, message = "Wystąpił błąd") => {
  try {
    if (error?.response?.data?.errors?.length > 0) {
      if (typeof error.response.data.errors === "string") {
        return error.response.data.errors;
      }
      return error.response.data.errors
        .map(({ source: { pointer }, detail }) =>
          [pointer.split("/").pop(), detail].join(" "),
        )
        .join(", ");
    }
    if (error?.response?.data?.error?.message) {
      return error.response.data?.error?.message;
    }
    if (error?.response?.data?.message) {
      return error.response.data.message;
    }
    if (error?.response?.data?.errors?.type) {
      return error.response.data.errors.type;
    }
    if (error?.message) {
      return error.message;
    }
    return message;
  } catch (error) {
    return message;
  }
};

export const stringifyQuery = (data) =>
  decodeURI(queryString.stringify(data, { arrayFormat: "bracket" }));

export const parseQuery = (data) =>
  queryString.parse(data, { arrayFormat: "bracket" });
